import React, { useState } from 'react';
import { X } from 'lucide-react';
interface TagInputProps {
  label: string;
  description?: string;
  placeholder?: string;
  tags: string[];
  onTagsChange: (tags: string[]) => void;
}
export function TagInput({
  label,
  description,
  placeholder,
  tags,
  onTagsChange
}: TagInputProps) {
  const [inputValue, setInputValue] = useState('');
  const parseInput = () => {
    if (!inputValue.trim()) return;
    // Split by comma, semicolon, or space
    const newTags = inputValue.split(/[,;\s]+/).map(tag => tag.trim()).filter(tag => tag.length > 0)
    // Filter out duplicates that already exist
    .filter(tag => !tags.includes(tag));
    if (newTags.length > 0) {
      onTagsChange([...tags, ...newTags]);
      setInputValue('');
    }
  };
  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      parseInput();
    }
  };
  const removeTag = (indexToRemove: number) => {
    onTagsChange(tags.filter((_, index) => index !== indexToRemove));
  };
  return <div className="space-y-3" data-id="element-768">
      <div className="space-y-1" data-id="element-769">
        <label className="block font-mono text-sm uppercase tracking-wider text-gray-500" data-id="element-770">
          {label}
        </label>
        {description && <p className="text-sm text-gray-400 font-light max-w-2xl" data-id="element-771">
            {description}
          </p>}
      </div>

      <input type="text" className="w-full border-2 border-gray-300 bg-transparent p-3 font-mono text-sm focus:border-gray-500 focus:outline-none placeholder:text-gray-300" placeholder={placeholder || 'Type and press enter or click away...'} value={inputValue} onChange={e => setInputValue(e.target.value)} onBlur={parseInput} onKeyDown={handleKeyDown} data-id="element-772" />

      {tags.length > 0 && <div className="flex flex-wrap gap-2 pt-2" data-id="element-773">
          {tags.map((tag, index) => <span key={`${tag}-${index}`} className="inline-flex items-center px-3 py-1 border border-gray-400 bg-white text-sm font-mono text-gray-700 group hover:border-red-400 hover:text-red-500 transition-colors cursor-pointer" onClick={() => removeTag(index)} data-id="element-774">
              {tag}
              <X className="w-3 h-3 ml-2 text-gray-400 group-hover:text-red-500" data-id="element-775" />
            </span>)}
        </div>}
    </div>;
}